module.exports = __webpack_public_path__ + "static/media/rc9.bd507830.jpg";